import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/loginStore';
import LoginPage from '../Pages/Login/LoginPage';
import HomePage from '../Pages/Home/HomePage';
import MaquinasPage from '../Pages/Maquinas/maquinasPage';
import ProdutosPage from "../Pages/Produtos/ProdutosPage";
import RelatoriosPage from "../Pages/Relatorios/RelatoriosPages";
import RelatoriosVendasPage from "../Pages/Relatorios/RelatorioDeVendas";
import GruposPage from "../Pages/Grupos/GruposPage";
import SubgruposPage from "../Pages/Subgrupos/SubgruposPage";
import FotosProdutos from "../Pages/FotosProdutos/FotosProdutosPages";
import UsuariosPage from "../Pages/Usuarios/UsuariosPage";
import ImpressaaoPage from '../Pages/Impressao/ImpressaoPage'
import LayoutPrivado from '../layout/Autenticado'; 

function AuthWatcher() {
  const logado = useAuthStore((state) => state.logado);
  const navigate = useNavigate();

  useEffect(() => {
    if (!logado) {
      navigate('/login');
    }
  }, [logado, navigate]);

  return null;
}

function RouterController() {
  return (
    <BrowserRouter>
      <AuthWatcher />
      <Routes>
        {/* Rota pública */}
        <Route path="/login" element={<LoginPage />} />

        {/* Rotas protegidas com layout */}
        <Route element={<LayoutPrivado />}>
          {/* <Route path="/" element={<Navigate to="/Home" />} /> */}
          <Route path="/Home" element={<HomePage />} />
          <Route path="/Maquinas" element={<MaquinasPage />} />
          <Route path="/Produtos" element={<ProdutosPage />} />
          <Route path="/Relatorios" element={<RelatoriosPage />} />
          <Route path="/RelatorioVendas" element={<RelatoriosVendasPage />} />
          <Route path="/Grupos" element={<GruposPage />} />
          <Route path="/SubGrupos" element={<SubgruposPage />} />
          <Route path="/FotosProdutos" element={<FotosProdutos />} />
          <Route path="/Usuarios" element={<UsuariosPage />} />
          <Route path="/Impressao" element={<ImpressaaoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default RouterController;
